// extracted by css-extract-rspack-plugin
export default {"container":"ThreadFilePath-module__container__DNq6r","file-name-overflow":"ThreadFilePath-module__file-name-overflow__Kw4OT"};